export default "__VITE_ASSET__8fb886ff__"